import { useEffect, useState } from 'react'
import { canalConfirmacion } from '../../lib/confirmar'
import Modal from './Modal'
import Button from './Button'

// La ventana de confirmación del sistema. Se monta una vez (App) y atiende los
// pedidos de confirmar()/pedirTexto() de cualquier pantalla. Va por encima de los
// otros modales: se confirma, por ejemplo, la baja de un pedido desde una ficha abierta.
export default function Confirmador() {
  const [pedido, setPedido] = useState(null)
  const [texto, setTexto] = useState('')

  useEffect(() => {
    canalConfirmacion.abrir = (p) => { setTexto(p.valorInicial || ''); setPedido(p) }
    return () => { canalConfirmacion.abrir = null }
  }, [])

  if (!pedido) return null

  const cerrar = (respuesta) => {
    pedido.resolve(respuesta)
    setPedido(null)
  }
  const falta = pedido.conTexto && pedido.obligatorio && !texto.trim()
  const aceptar = () => {
    if (falta) return
    cerrar(pedido.conTexto ? texto.trim() : true)
  }
  const peligro = pedido.peligro !== false

  return (
    <div className="relative z-[200]">
      <Modal isOpen onClose={() => cerrar(pedido.conTexto ? null : false)} title={pedido.titulo} size="sm">
        <form className="space-y-4" onSubmit={(e) => { e.preventDefault(); aceptar() }}>
          {pedido.mensaje && <p className="whitespace-pre-line text-sm leading-relaxed text-ink-soft">{pedido.mensaje}</p>}
          {pedido.conTexto && (
            <label className="block">
              {pedido.etiqueta && <span className="mb-1 block text-xs font-bold uppercase tracking-wide text-ink-muted">{pedido.etiqueta}{pedido.obligatorio ? ' *' : ''}</span>}
              <textarea autoFocus rows={3} className="input text-sm" value={texto} placeholder={pedido.placeholder || ''}
                onChange={(e) => setTexto(e.target.value)}
                onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); aceptar() } }} />
            </label>
          )}
          <div className="flex justify-end gap-2">
            <Button type="button" variant="ghost" onClick={() => cerrar(pedido.conTexto ? null : false)}>Cancelar</Button>
            <Button type="submit" variant={peligro ? 'danger' : 'social'} disabled={falta} autoFocus={!pedido.conTexto}>
              {pedido.accion || 'Aceptar'}
            </Button>
          </div>
        </form>
      </Modal>
    </div>
  )
}
